module.exports = __webpack_public_path__ + "static/img/3_03.e9d9950.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/3_03.png
// module id = HsLd
// module chunks = 3